import React from "react";
import { Box, Button, ButtonGroup, Typography } from "@material-ui/core";
import I18nText from "../../../elements/I18nText";

const DeviceTypeFilter = ({
  typeFilter,
  onTypeFilterChange,
  TYPE_BUTTONS,
  showLabel = false
}) => {
  return (
    <Box marginBottom={showLabel ? 2 : 1}>
      {showLabel && (
        <Typography variant="subtitle2" gutterBottom>
          <I18nText>topbar.filter.deviceType</I18nText>
        </Typography>
      )}
      <ButtonGroup size="small" color="primary" aria-label="device type filter">
        {TYPE_BUTTONS.map(btn => (
          <Button
            key={btn.value}
            onClick={() => onTypeFilterChange(btn.value)}
            variant={typeFilter === btn.value ? "contained" : "outlined"}
            color={typeFilter === btn.value ? "primary" : "default"}
          >
            {btn.label}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
};

export default DeviceTypeFilter;
